import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  Alert,
  CircularProgress
} from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';

const Login = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [formData, setFormData] = useState({
    login: '',
    mdp: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const result = await login(formData);

    if (result.success) {
      navigate('/dashboard');
    } else {
      setError(result.message);
    }
    setLoading(false);
  };

    return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #3d7a7f 0%, #2d6a6f 50%, #3d7a7f 100%)',
        padding: 2
      }}
    >
      <Card
        sx={{
          maxWidth: 500,
          width: '100%',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
          borderRadius: 3
        }}
      >
        <CardContent sx={{ p: 4 }}>
          {/* Logo */}
          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
            <img 
              src="/veto-logo.png" 
              alt="Véto Logo" 
              style={{ 
                height: '120px',
                maxWidth: '100%',
                objectFit: 'contain'
              }} 
            />
          </Box>

          {/* Message d'erreur */}
          {error && (
            <Alert severity="error" sx={{ mb: 3 }}>
              {error}
            </Alert>
          )}

          {/* Formulaire */}
          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="Login"
              name="login"
              value={formData.login}
              onChange={handleChange}
              required
              margin="normal"
              autoFocus
              disabled={loading}
              sx={{ 
                mb: 2,
                '& .MuiInputLabel-root': {
                  fontWeight: 700
                }
              }}
            />

            <TextField
              fullWidth
              label="Mot de passe"
              name="mdp"
              type="password"
              value={formData.mdp}
              onChange={handleChange}
              required
              margin="normal"
              disabled={loading}
              sx={{ 
                mb: 3,
                '& .MuiInputLabel-root': {
                  fontWeight: 700
                }
              }}
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              size="large"
              disabled={loading}
              sx={{
                py: 1.5,
                backgroundColor: '#3d7a7f',
                '&:hover': {
                  backgroundColor: '#2d6a6f',
                },
                textTransform: 'uppercase',
                fontWeight: 600,
                fontSize: '1rem'
              }}
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                'SE CONNECTER'
              )}
            </Button>
          </form>

          {/* Footer */}
          <Typography 
            variant="caption" 
            align="center" 
            color="textSecondary" 
            display="block" 
            sx={{ mt: 3 }}
          >
            © 2025 Vetolik 
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Login;